import styled from "styled-components";

export const ImageWrapper = styled.div(props => ({
    "& img": {
        maxHeight: "32px",
    },
    ["@media" + props.theme.device.laptopM]: {
        "& img": {
            maxHeight: "18px"
        },
    },
}));
